import axios from 'axios';

const uri = '/fields';

const state = {
  entries: [],
  fields: [
    {
      name: 'label',
      label: 'Label',
      type: 'text',
      sluggify: 'key',
    },
    {
      name: 'key',
      label: 'Key',
      type: 'text',
    },
    {
      name: 'type',
      label: 'Type',
      type: 'select',
      default: 'text',
      options: [
        {
          key: 'text',
          label: 'Text',
        },
        {
          key: 'textarea',
          label: 'Text Area',
        },
        {
          key: 'email',
          label: 'E-mail',
        },
        {
          key: 'password',
          label: 'Password',
        },
        {
          key: 'select',
          label: 'Select',
        },
        {
          key: 'ref',
          label: 'Reference',
        },
        {
          key: 'number',
          label: 'Number',
        },
        {
          key: 'float',
          label: 'Float',
        },
        {
          key: 'true/false',
          label: 'True/False',
        },
        {
          key: 'checkbox',
          label: 'Checkbox',
        },
        {
          key: 'date',
          label: 'Date',
        },
        {
          key: 'time',
          label: 'Time',
        },
        {
          key: 'color',
          label: 'Color',
        },
        {
          key: 'upload',
          label: 'Upload',
        },
        {
          key: 'repeater',
          label: 'Repeater',
        },
      ],
    },
    {
      name: 'object_type',
      label: 'Object Type',
      type: 'ref',
      options: 'types',
      default: '(first)',
    },
    {
      name: 'default',
      label: 'Default',
      type: 'text',
    },
    {
      name: 'placeholder',
      label: 'Placeholder',
      type: 'text',
    },
    {
      name: 'instructions',
      label: 'Instructions',
      type: 'text',
    },
  ],
};

// getters
const getters = {
  getFields(state) {
    return state.fields;
  },
  getTypeFields(state) {
    return object_type =>
      state.entries.filter(item => item.object_type === object_type);
  },
};

// actions
const actions = {
  async add({ commit }, { object, callback }) {
    const { data } = await axios.post(`${uri}`, object);
    commit('add', data);

    if (typeof callback === 'function') {
      callback(data);
    }
  },
  async get({ commit }, input) {
    const { data } = await axios.get(`${uri}`);
    commit('get', data);

    if (typeof input !== 'undefined' && typeof input.callback === 'function') {
      input.callback(data);
    }
  },
  async update({ commit }, { object, callback }) {
    const { data } = await axios.put(`${uri}`, object);
    commit('set', data);

    if (typeof callback === 'function') {
      callback(data);
    }
  },
  async delete({ commit }, { id, callback }) {
    await axios.delete(`${uri}`, {
      params: {
        id,
      },
    });
    commit('delete', id);

    if (typeof callback === 'function') {
      callback();
    }
  },
};

// mutations
const mutations = {
  add(state, entry) {
    state.entries.push(entry);
  },
  get(state, data) {
    const prepared = [];
    data.forEach(element => {
      if (typeof element.name === 'undefined' && element.key !== 'undefined') {
        element.name = element.key;
      }
      prepared.push(element);
    });
    state.entries = prepared;
  },
  set(state, data) {
    state.entries.forEach(element => {
      if (element._id === data._id) {
        element = data;
      }
    });
  },
  delete(state, id) {
    state.entries = state.entries.filter(element => element._id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
